import axios from './axios';

const getAll = async () => {
	const response = await axios.get('/companies');
	return response;
};

export { getAll };
